import { render, staticRenderFns } from "./ClientAuditHistory.vue?vue&type=template&id=58325dfc"
import script from "./ClientAuditHistory.vue?vue&type=script&lang=js"
export * from "./ClientAuditHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports